<script setup lang="ts">
  import { Minus, Plus } from 'lucide-vue-next';

  defineProps<{
    percent: number;
    canZoomIn: boolean;
    canZoomOut: boolean;
  }>();

  const emit = defineEmits<{
    (e: 'zoomIn'): void;
    (e: 'zoomOut'): void;
  }>();

  const BUTTON_CLASS =
    'flex cursor-pointer items-center px-2.5 hover:text-gray-07 focus-visible:rounded-md focus-visible:outline-2 focus-visible:outline-offset-[-2px] focus-visible:outline-[var(--theme-secondary-ink)] disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:text-gray-03';
</script>

<template>
  <div
    class="flex max-w-fit divide-x divide-gray-02 rounded-lg bg-[var(--theme-secondary-tint-subtle)] p-0.5 text-gray-03"
    role="group"
    aria-label="Zoom da folha"
    data-testid="fill-logs-zoom"
  >
    <button
      type="button"
      :class="BUTTON_CLASS"
      :disabled="!canZoomOut"
      aria-label="Diminuir zoom"
      data-testid="fill-logs-zoom-out"
      @click="emit('zoomOut')"
    >
      <Minus
        :size="16"
        aria-hidden="true"
      />
    </button>
    <output
      class="min-w-[4.5rem] px-3 py-1.5 text-center text-gray-07 tabular-nums"
      aria-live="polite"
      data-testid="fill-logs-zoom-value"
    >
      {{ percent }}%
    </output>
    <button
      type="button"
      :class="BUTTON_CLASS"
      :disabled="!canZoomIn"
      aria-label="Aumentar zoom"
      data-testid="fill-logs-zoom-in"
      @click="emit('zoomIn')"
    >
      <Plus
        :size="16"
        aria-hidden="true"
      />
    </button>
  </div>
</template>
